<template>
  <v-container class="px-5 col-12 entity-tree-container">
    <material-card color="teal" class="mb-0" style="margin-top: 32px;">
      <template v-slot:header>
        <div class="px-3">
          <h4 class="title font-weight-light mb-0">Account Registration</h4>
        </div>
      </template>

      <h2 v-if="$vuetify.breakpoint.name == 'xs'" class="text-center">
        <v-icon x-large class="mb-5">mdi-phone-rotate-landscape</v-icon>
        <br />
        Put your phone in landscape mode
      </h2>

      <v-form
        v-else
        v-model="valid"
        ref="account_registration"
        style="overflow: hidden"
      >
        <v-row>
          <v-col cols="6">
            <select-project
              :disabled="loading"
              v-model="account.entity_id"
              :project-list-custom="projectList"
              :rules="[v => !!v || 'Project is required']"
            />

            <v-text-field
              :disabled="loading"
              v-model="account.login"
              label="Login"
              :rules="[v => !!v || 'Login is required']"
              required
            />

            <v-text-field
              :disabled="loading"
              v-model="account.password"
              label="Password"
              persistent-hint
              hint="Copy password before create"
              append-outer-icon="mdi-lock-reset"
              @click:append-outer="generatePassword()"
              :rules="[v => !!v || 'Password is required']"
              required
            />


            <v-select
              :disabled="loading"
              v-model="account.currency"
              :items="currencies[account.entity_id] ? currencies[account.entity_id].currencies : []"
              :rules="[v => !!v || 'Currency is required']"
              label="Currency"
              required
            />

            <v-row class="mx-0">
              <v-text-field
                :disabled="loading"
                v-model="account.phone"
                label="Phone"
                data-vv-name="phone"
                :rules="[v => !!v || 'Phone is required']"
                required
              />

            </v-row>

          </v-col>

          <v-col cols="6">
            <v-row>
              <v-text-field
                :disabled="loading"
                v-model="account.profile.name"
                label="Name"
                data-vv-name="name"
                class="col-6 pt-3 pb-0"
                :rules="[v => !!v || 'Name is required']"
                required
              />
              <v-text-field
                :disabled="loading"
                v-model="account.profile.surname"
                label="Surname"
                data-vv-name="surname"
                class="col-6 pt-3 pb-0"
                :rules="[v => !!v || 'Surname is required']"
                required
              />
            </v-row>
            <v-row>
              <v-text-field
                :disabled="loading"
                v-model="account.profile.birthday"
                label="Birthday date"
                placeholder="YYYY-MM-DD"
                prepend-icon="event"
                data-vv-name="birthday"
                v-mask="`####-##-##`"
                class="col-6 pt-3 pb-0"
                :rules="[v => !!v || 'Birthday is required']"
                required
              />
              <v-select
                :disabled="loading"
                label="Gender"
                placeholder="Male/Female"
                v-model="account.profile.gender"
                data-vv-name="gender"
                :items="genderList"
                class="col-6 pt-3 pb-0"
                :rules="[v => !!v || 'Gender is required']"
                required
              />
            </v-row>
            <v-row>
              <v-text-field
                :disabled="loading"
                v-model="account.language"
                label="Language"
                placeholder="EN/RU/PL etc"
                append-icon="flag"
                data-vv-name="language"
                v-mask="`AA`"
                class="col-6 pt-3 pb-0"
                :rules="[v => !!v || 'Language is required']"
                required
              />
              <v-autocomplete
                :disabled="loading"
                label="Country"
                v-model="account.country"
                data-vv-name="country"
                item-value="code"
                item-text="title"
                :items="$store.state.app.countries"
                class="col-6 pt-3 pb-0"
                :rules="[v => !!v || 'Country is required']"
                required
                auto-select-first
              />
            </v-row>

            <v-row>
              <v-text-field
                :disabled="loading"
                v-model="account.profile.city"
                label="City"
                placeholder="Moscow/London/Berlin etc"
                data-vv-name="city"
                class="col-4 pt-3 pb-0"
                :rules="[v => !!v || 'City is required']"
                required
              />
              <v-text-field
                :disabled="loading"
                v-model="account.profile.address"
                label="Address Line"
                placeholder="Snowy Rock Pl"
                data-vv-name="address"
                class="col-4 pt-3 pb-0"
                :rules="[v => !!v || 'Address is required']"
                required
              />
              <v-text-field
                :disabled="loading"
                v-model="account.profile.postcode"
                label="Post Code"
                placeholder="BG1000"
                data-vv-name="postcode"
                class="col-4 pt-3 pb-0"
                :rules="[v => !!v || 'Postcode is required']"
                required
              />
            </v-row>

            <v-row class="mx-0">
              <v-text-field
                :disabled="loading"
                v-model="account.email"
                label="Email"
                data-vv-name="email"
                :rules="[v => !!v || 'Email is required']"
                required
              />

              <!--              <v-checkbox-->
              <!--                :disabled="loading"-->
              <!--                label="Activated"-->
              <!--                v-model="account.is_valid.email"-->
              <!--                hide-details-->
              <!--                :false-value="0"-->
              <!--                :true-value="1"-->
              <!--                class="ml-5"-->
              <!--              />-->
            </v-row>

          </v-col>
        </v-row>

        <v-row class="mx-auto px-6">
          <v-spacer />
          <v-btn
            :loading="loading"
            :disabled="loading"
            @click="save()"
            class="mr-8"
            color="primary"
          >Save
          </v-btn>
          <v-btn
            :loading="loading"
            :disabled="loading"
            @click="reset()"
            color="warning"
          >Reset
          </v-btn>
        </v-row>

      </v-form>


    </material-card>

    <material-notification
      v-for="a in accounts"
      :key="a.account_id"
      class="mb-3 mt-3"
      color="success"
      dismissible
    >
      <v-icon style="margin-top: -4px;" class="mr-3">check</v-icon>
      <span style="font-size: 15px">Account created ID: {{ a.account_id }} | Login: <a :href="'/user-management/'  + a.login" class="white--text" target="_blank">{{ a.login }}</a></span>
    </material-notification>

  </v-container>
</template>

<style>


</style>

<script>
  import { API } from '@/utils/api'
  import { map, keyBy } from 'lodash'
  import { mask } from 'vue-the-mask'
  import SelectProject from '@/components/core/SelectProject/SelectProject.vue'

  export default {
    directives: {
      mask,
    },
    components: { SelectProject },

    data: () => ({
      genderList: [ { text: 'Male', value: 'M' }, { text: 'Female', value: 'F' } ],
      valid: true,
      loading: false,
      currencies: {},
      account: {
        entity_id: 0,
        country: 'TN',
        language: 'FR',
        password: '',
        is_valid: {},
        profile: {}
      },
      projectList: [],
      accounts: []
    }),

    mounted () {
      this.loadProjects()
    },

    computed: {},

    watch: {},

    methods: {
      reset () {
        this.loading = false
        this.valid = true
        this.$refs.account_registration.reset()

        this.$nextTick(() => {
          this.account = {
            country: 'TN',
            language: 'FR',
            password: '',
            is_valid: {},
            profile: {}
          }
        })
      },

      save () {
        if (!this.$refs.account_registration.validate()) {
          return
        }

        this.loading = true
        return API.call('/kiosk/account/create.json', { account: this.account }, null, this.account.entity_id).then(r => {

          this.$notification.show = true
          this.$notification.message = `Account Created: ${(r.data.prefix + r.data.login).toUpperCase()}`
          this.$notification.type = 'success'

          this.accounts.push({ login: (r.data.prefix + r.data.login).toUpperCase(), account_id: r.data.account_id })
          this.reset()
        }).catch(e => {
        }).finally(r => {
          this.loading = false
        })
      },

      loadProjects () {
        return API.call('/kiosk/project_list.json', {}).then(r => {
          this.projectList = map(r.data, (i) => ({ text: i.name, value: i.entity_id, currencies: i.currencies ? i.currencies : this.$store.state.auth.currencies }))
          if (this.projectList[0]) {
            this.account.entity_id = this.projectList[0].value
          }
          this.currencies = keyBy(this.projectList, 'value')
        })
      },

      generatePassword () {
        this.account.password = (Math.random().toString(36) + '00000000000000000').slice(2, 8).toUpperCase() + (Math.random().toString(36) + '00000000000000000').slice(2, 8)
      },
    }

  }
</script>
